export default "__VITE_ASSET__C$EooAoB__"